module.exports = __webpack_public_path__ + "img/mini-code.7b995049.jpg";